module.exports = __webpack_public_path__ + "img/player_run_004.7dd8fa32.png";